import { apiClient } from "api/client";

// ==================== user ====================

// 로그인 아이디로 유저 조회 (삭제되지 않은 유저만, lastLogin 갱신됨).
// 서버는 recordset(Array)을 그대로 반환한다. Firestore의 login() 반환 shape과 호환.
export async function getUserById(id) {
  const { data } = await apiClient.get("/get/user", { params: { id } });
  return Array.isArray(data) ? data : [];
}

// 차단한 유저 목록 조회. recordset(Array) 반환.
export async function getBlockedUsersApi(userDocId) {
  const { data } = await apiClient.get("/get/user/blocked", {
    params: { userDocId },
  });
  return Array.isArray(data) ? data : [];
}

// 유저 등록. 서버는 { success, docId } 반환.
export async function registerUserApi(body) {
  const { data } = await apiClient.post("/post/user/register", body);
  return data;
}

// 유저 정보 수정. 서버는 { success } 반환.
export async function updateUserApi(body) {
  const { data } = await apiClient.post("/post/user/update", body);
  return data;
}

// 유저 삭제 (soft delete: deleteDate 세팅). { success } 반환.
export async function deleteUserApi(docId) {
  const { data } = await apiClient.post("/post/user/delete", { docId });
  return data;
}

// 유저 차단. { success, docId? } 반환.
export async function blockUserApi(body) {
  const { data } = await apiClient.post("/post/user/block", body);
  return data;
}

// 유저 차단 해제. { success } 반환.
export async function unblockUserApi(userDocId, id) {
  const { data } = await apiClient.post("/post/user/unblock", {
    userDocId,
    id,
  });
  return data;
}

// 포인트 충전(결제). { success, ... } 반환.
export async function chargePointApi(body) {
  const { data } = await apiClient.post("/post/user/chargePoint", body);
  return data;
}

// ==================== alarmSetting ====================

export async function getAlarmSettingApi(id) {
  const { data } = await apiClient.get("/get/alarmSetting", { params: { id } });
  return Array.isArray(data) ? data : [];
}

export async function createAlarmSettingApi(body) {
  const { data } = await apiClient.post("/post/alarmSetting/create", body);
  return data;
}

export async function updateAlarmSettingApi(body) {
  const { data } = await apiClient.post("/post/alarmSetting/update", body);
  return data;
}
